function cov_1zvneyecpx() {
  var path = "/app/src/utils/get-element.ts";
  var hash = "49e05a0e76af0c7bac4dac8cece9a24405c90323";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-element.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 26
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 29
        }
      },
      "2": {
        start: {
          line: 2,
          column: 17
        },
        end: {
          line: 2,
          column: 29
        }
      },
      "3": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 8,
          column: 3
        }
      },
      "4": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 57
        }
      },
      "5": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 26
          },
          end: {
            line: 1,
            column: 27
          }
        },
        loc: {
          start: {
            line: 1,
            column: 49
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 29
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 2
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "49e05a0e76af0c7bac4dac8cece9a24405c90323"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1zvneyecpx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1zvneyecpx();
cov_1zvneyecpx().s[0]++;
export var getElement = function getElement(selector) {
  cov_1zvneyecpx().f[0]++;
  cov_1zvneyecpx().s[1]++;
  if (!selector) {
    cov_1zvneyecpx().b[0][0]++;
    cov_1zvneyecpx().s[2]++;
    return null;
  } else {
    cov_1zvneyecpx().b[0][1]++;
  }
  cov_1zvneyecpx().s[3]++;
  try {
    cov_1zvneyecpx().s[4]++;
    return document.querySelector(selector);
  } catch (_unused) {
    cov_1zvneyecpx().s[5]++;
    return null;
  }
};